<div class="page-wrapper">
  <div class="deco-blob-1"></div>
  <div class="deco-blob-2"></div>
  <div class="grid-overlay"></div>

  <div class="page-container">
    <!-- Header -->
    <header class="top-nav">
      <div class="hero-logo">
        <img src="../../assets/images/Logo.svg" alt="Nishwik Logo" class="img-fluid" />
      </div>
      <div class="nav-right">
        Already registered?
        <a routerLink="/login" class="link-btn">
          Sign In <i class="fas fa-arrow-right"></i>
        </a>
      </div>
    </header>

    <main class="main-content">
      <!-- Left Info Panel -->
      <section class="info-panel">
        <div class="badge-pill">
          <span class="badge-dot"></span>
          Next-Gen Healthcare Management
        </div>

        <h1 class="display-title">
          Join the Future<br />of <span class="gradient-text">Digital Healthcare.</span>
        </h1>

        <p class="panel-desc">
          Simplify clinical workflows, empower patients, and optimize hospital
          operations with our unified operating system — built for India's modern healthcare.
        </p>

        <div class="features-list">
          <div class="feature-item">
            <div class="f-icon">
              <i class="fas fa-heartbeat"></i>
            </div>
            <div class="f-content">
              <div class="f-title">Real-time Patient Monitoring</div>
              <div class="f-desc">Live vitals, alerts, and dashboards for clinical teams</div>
            </div>
          </div>
          <div class="feature-item">
            <div class="f-icon">
              <i class="fas fa-file-medical"></i>
            </div>
            <div class="f-content">
              <div class="f-title">Secure EHR Management</div>
              <div class="f-desc">End-to-end encrypted electronic health records</div>
            </div>
          </div>
          <div class="feature-item">
            <div class="f-icon">
              <i class="fas fa-calendar-check"></i>
            </div>
            <div class="f-content">
              <div class="f-title">Automated Scheduling</div>
              <div class="f-desc">Smart OPD and appointment management at scale</div>
            </div>
          </div>
        </div>

        <!-- <div class="trust-strip">
          <div class="trust-stat">
            <span class="stat-num">500+</span>
            <span class="stat-label">Hospitals</span>
          </div>
          <div class="trust-divider"></div>
          <div class="trust-stat">
            <span class="stat-num">2M+</span>
            <span class="stat-label">Patients</span>
          </div>
          <div class="trust-divider"></div>
          <div class="trust-stat">
            <span class="stat-num">99.9%</span>
            <span class="stat-label">Uptime</span>
          </div>
        </div> -->
      </section>

      <!-- Right Form Panel -->
      <section class="form-panel">
        <div class="signup-card">
          <div class="card-top-bar"></div>

          <div class="card-inner">
            <div class="card-header">
              <div class="card-eyebrow">Hospital OS · Registration</div>
              <h2>Create Your Account</h2>
              <p>Fill in your details to get started</p>
            </div>

            <!-- Role Selector -->
            <!-- <div class="role-selector">
              <div *ngFor="let r of roles"
                   class="role-card"
                   [class.active]="selectedRole === r.id"
                   (click)="selectRole(r.id)">
                <div class="role-icon-wrap">
                  <i [class]="r.icon"></i>
                </div>
                <div class="role-info">
                  <span class="role-label">{{ r.label }}</span>
                  <span class="role-desc">{{ r.description }}</span>
                </div>
                <div class="role-check"><i class="fas fa-check"></i></div>
              </div>
            </div> -->

            <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">

              <!-- Personal Information -->
              <div class="form-section">
                <div class="section-header">
                  <div class="section-num">01</div>
                  <h3 class="section-label">Personal Information</h3>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>First Name <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-user input-icon"></i>
                      <input type="text" formControlName="firstName" placeholder="John" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('firstName')?.touched && signupForm.get('firstName')?.hasError('required')">
                      First name is required.
                    </small>
                  </div>
                  <div class="input-group">
                    <label>Last Name <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-user input-icon"></i>
                      <input type="text" formControlName="lastName" placeholder="Doe" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('lastName')?.touched && signupForm.get('lastName')?.hasError('required')">
                      Last name is required.
                    </small>
                  </div>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>Email Address <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-envelope input-icon"></i>
                      <input type="email" formControlName="email" placeholder="john@hospital.com" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.hasError('required')">Email is required.</small>
                    <small class="field-error" *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.hasError('email')">Enter a valid email address.</small>
                  </div>
                  <div class="input-group">
                    <label>Mobile Number <span class="req">*</span></label>
                    <div class="input-wrap mobile-wrap">
                      <i class="fas fa-mobile-alt input-icon"></i>
                      <input type="tel" formControlName="mobileNumber" placeholder="9876543210" />
                      <!-- <button type="button" class="btn-otp" (click)="sendOtp()" [disabled]="otpSent && otpTimer > 0">
                        <span *ngIf="!otpSent"><i class="fas fa-paper-plane"></i> Verify</span>
                        <span *ngIf="otpSent && otpTimer > 0"><i class="fas fa-clock"></i> {{ otpTimer }}s</span>
                        <span *ngIf="otpSent && otpTimer === 0"><i class="fas fa-redo"></i> Resend</span>
                      </button> -->
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('mobileNumber')?.touched && signupForm.get('mobileNumber')?.hasError('pattern')">Enter a valid 10-digit mobile number.</small>
                  </div>
                </div>
              </div>

              <!-- Professional Credentials (Conditional) -->
              <!-- <div class="form-section animate-fade" *ngIf="selectedRole !== 'Patient'">
                <div class="section-header">
                  <div class="section-num">02</div>
                  <h3 class="section-label">Professional Credentials</h3>
                </div>

                <div class="form-row">
                  <div class="input-group" *ngIf="selectedRole === 'Doctor'">
                    <label>Specialization <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-stethoscope input-icon"></i>
                      <input type="text" formControlName="specialization" placeholder="e.g. Cardiology" />
                    </div>
                  </div>
                  <div class="input-group" *ngIf="selectedRole === 'Doctor'">
                    <label>Medical License # <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-id-card input-icon"></i>
                      <input type="text" formControlName="licenseNumber" placeholder="LIC-123456" />
                    </div>
                  </div>
                  <div class="input-group" *ngIf="selectedRole === 'Staff'">
                    <label>Employee ID</label>
                    <div class="input-wrap">
                      <i class="fas fa-id-badge input-icon"></i>
                      <input type="text" formControlName="employeeId" placeholder="EMP-001" />
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- Account Security -->
              <div class="form-section">
                <div class="section-header">
                  <div class="section-num" [class]="selectedRole !== 'Patient' ? '' : 'num-02'">
                    {{ selectedRole !== 'Patient' ? '03' : '02' }}
                  </div>
                  <h3 class="section-label">Account Security</h3>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>Username <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-at input-icon"></i>
                      <input type="text" formControlName="username" placeholder="johndoe_med" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('username')?.touched && signupForm.get('username')?.hasError('required')">Username is required.</small>
                  </div>
                  <div class="input-group" *ngIf="otpSent">
                    <label>Verify OTP <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-shield-alt input-icon"></i>
                      <input type="text" formControlName="otp" placeholder="6-digit code" maxlength="6" class="otp-input" />
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>Password <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-lock input-icon"></i>
                      <input type="password" formControlName="password" placeholder="Min. 6 characters" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('password')?.touched && signupForm.get('password')?.hasError('minlength')">Password must be at least 6 characters.</small>
                  </div>
                  <div class="input-group">
                    <label>Confirm Password <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-lock input-icon"></i>
                      <input type="password" formControlName="confirmPassword" placeholder="Re-enter password" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.hasError('mismatch') && signupForm.get('confirmPassword')?.touched">Passwords do not match.</small>
                  </div>
                </div>
              </div>

              <button type="submit" class="btn-submit" [disabled]="signupForm.invalid">
                <span>Complete Registration</span>
                <i class="fas fa-arrow-right"></i>
              </button>

              <p class="terms-text">
                By registering, you agree to our
                <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.
              </p>
            </form>
          </div>
        </div>
      </section>
    </main>

    <footer class="bottom-bar">
      <span>&copy; 2026 Nishwik Hospital OS. Built for modern healthcare.</span>
      <!-- <div class="social-links">
        <a href="#" aria-label="LinkedIn"><i class="fab fa-linkedin"></i></a>
        <a href="#" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
      </div> -->
    </footer>
  </div>
</div>